import { render } from "./ExamInfoUnderlyingDiseases.vue?vue&type=template&id=e593d4bc&scoped=true"
import script from "./ExamInfoUnderlyingDiseases.vue?vue&type=script&lang=js"
export * from "./ExamInfoUnderlyingDiseases.vue?vue&type=script&lang=js"

import "./ExamInfoUnderlyingDiseases.vue?vue&type=style&index=0&id=e593d4bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e593d4bc"]])

export default __exports__